import httpClient from '@/shared/http-eserv-client';

const getPermitPrices = () => httpClient.get("/Products/availableprices?$filter=producttype eq 'Permit' and ProductCode ne 'STSOP'");

const getSearchRequestPrices = () => httpClient.get("/Products/availableprices?$filter=producttype eq 'Search'");

const getHistoricalPrices = () => httpClient.get('/Products?$expand=pricechangelogs');

const getOperationalPrices = () => httpClient.get('/Products/OperationalPermitFeeList');

const getMiscellaneousPrices = () => httpClient.get("/Products/availableprices?$filter=category eq 'Miscellaneous Fee'");

const postProductPrice = (data) => httpClient.post('/prices', data);
const getJobEventLogs = (jobCode) => httpClient.get(`/EventHistories?$filter=jobcode eq '${jobCode}'`);
const addNewPrice = (productId, amountApp, amountTank, amountLevy, amountPerAddress,
  levyFeeType, chargeBy, effectiveStartDate) => httpClient.post('/prices', {
  productId,
  amountApp,
  amountTank,
  amountLevy,
  amountPerAddress,
  levyFeeType,
  chargeBy,
  effectiveStartDate,
});

const getProductPrice = (priceId) => httpClient.get(`/Products/${priceId}`);

const getProductTypes = () => httpClient.get("/Products?$filter=ProductCode ne 'STSOP'");

const getChargeBys = () => httpClient.get('/PriceChargeBys');

// eslint-disable-next-line import/prefer-default-export
export {
  getPermitPrices, getSearchRequestPrices, getHistoricalPrices,
  getOperationalPrices, addNewPrice, getProductPrice,
  getProductTypes, getChargeBys, postProductPrice, getJobEventLogs,
  getMiscellaneousPrices,
};
